import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FieldConfig } from 'projects/borrower-app/src/app/models/wizard/config/field-config-model';
import { MyInfoStep } from 'projects/borrower-app/src/app/models/wizard/my-info-step.model';
import { FieldConfigEditorComponent } from '../field-config-editor/field-config-editor.component';

@Component({
    selector: 'my-info-step-editor',
    templateUrl: 'my-info-step-editor.component.html',
    standalone: false
})

export class MyInfoStepEditorComponent implements OnInit, AfterViewInit {

  @ViewChild("borrowerFieldsConfigEditor") borrowerFieldsConfigEditor: FieldConfigEditorComponent | undefined;

  @ViewChild("addressFieldsConfigEditor") addressFieldsConfigEditor: FieldConfigEditorComponent | undefined;

  @Input()
  step!: MyInfoStep;

  // LLS-255: the single flow-wide flag, two-way bound from the host step so the toggle renders
  // grouped with the other My Info toggles (above the field-config tables). The host owns storage
  // (the flow config); this editor only renders/edits it.
  @Input()
  allowBorrowerEnterCoBorrowerPersonalInformation: boolean = true;

  @Output()
  allowBorrowerEnterCoBorrowerPersonalInformationChange = new EventEmitter<boolean>();

  // Hidden in the Co-Apply flow, where the flag does not apply.
  @Input()
  canConfigureCoBorrowerPersonalInfo: boolean = true;

  constructor() { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.borrowerFieldsConfigEditor) {
        const fieldConfigs: FieldConfig[] = this.step.getFieldsToConfig(this.step.borrowerFieldsConfig);
        this.borrowerFieldsConfigEditor.fieldConfigs = fieldConfigs;
      }
      if (this.addressFieldsConfigEditor) {
        const fieldConfigs: FieldConfig[] = this.step.getFieldsToConfig(this.step.addressFieldsConfig);
        this.addressFieldsConfigEditor.fieldConfigs = fieldConfigs;
      }
    });
  }

  ngOnInit() { }
}
